import { Fade } from "react-awesome-reveal";
import { connect } from "react-redux";
import {
    CloudMoon,
    CloudSun,
    Sun,
    GitHub,
    LinkedIn,
    Medium,
    YouTube,
    Bulb,
} from "./UI/icons";

const Button = (props) => (
    <button
        aria-label={props.ariaLabel}
        onClick={() => props.toggleTheme(props.selfThemeType)}
        className={
            props.currentThemeType === props.selfThemeType
                ? "opacity-100"
                : "opacity-50 hover:opacity-80"
        }
    >
        {props.children}
    </button>
);

const AnchorTag = (props) => (
    <a href={props.link} className="opacity-80 hover:opacity-100">
        {props.children}
    </a>
);

const ExternalLinks = () => {
    const classes = "w-7 sm:w-8";
    return (
        <div className="mx-auto w-full xxxs:w-10/12 xxs:w-8/12 xs:w-7/12 sm:w-6/12 md:w-5/12 lg:w-4/12 pt-4 flex justify-around border-footer border-t-2 border-solid">
            <Fade direction="up" cascade triggerOnce delay={1500}>
                <AnchorTag link="https://github.com/dhyeythumar">
                    <GitHub customClasses={classes} />
                </AnchorTag>
                <AnchorTag link="https://www.linkedin.com/in/dhyeythumar/">
                    <LinkedIn customClasses={classes} />
                </AnchorTag>
                <AnchorTag link="https://dhyeythumar.medium.com/">
                    <Medium customClasses={classes} />
                </AnchorTag>
                <AnchorTag link="https://www.youtube.com/channel/UCpKizIKSk8ga_LCI3e3GUig">
                    <YouTube customClasses={classes} />
                </AnchorTag>
            </Fade>
        </div>
    );
};

const Footer = (props) => {
    const dateTime = new Date()
        .toLocaleString("en-in", {
            timeZone: "Asia/Kolkata",
            hour: "numeric",
            minute: "numeric",
            hour12: true,
        })
        .toUpperCase();

    return (
        <footer className="bg-footer-color text-footer-color" id="footer">
            <div className="section-size py-6 px-6 sm:px-10 space-y-6 lg:space-y-8">
                <span className="flex flex-row justify-center lg:justify-end space-x-8">
                    <Fade direction="up" triggerOnce duration={500}>
                        <Button
                            ariaLabel="Night Mode"
                            selfThemeType="night"
                            {...props}
                        >
                            <CloudMoon customClasses="w-5 lg:w-6" />
                        </Button>
                        <Button
                            ariaLabel="Morning Mode"
                            selfThemeType="morning"
                            {...props}
                        >
                            <CloudSun customClasses="w-6 lg:w-7" />
                        </Button>
                        <Button
                            ariaLabel="Evening Mode"
                            selfThemeType="evening"
                            {...props}
                        >
                            <Sun customClasses="w-5 lg:w-6" />
                        </Button>
                    </Fade>
                </span>

                <div className="w-auto" translate="no">
                    <Fade direction="down" triggerOnce delay={500}>
                        <div className="w-4/12 mx-auto mb-2 font-gotu font-normal text-2xl sm:text-3xl lg:text-4xl text-center">
                            dh.
                        </div>
                    </Fade>
                    <ExternalLinks />
                </div>

                <div className="w-full pt-4 text-xs sm:text-sm tracking-wider font-ssp font-normal text-center space-y-2 lg:space-y-0 grid grid-cols-1 lg:grid-cols-3 mx-auto">
                    <Fade direction="up" cascade triggerOnce delay={2000}>
                        <div className="align-middle lg:text-left">
                            Last Update on {props.updatedAt}
                        </div>
                        <div className="inline-flex sm:space-x-2 align-middle">
                            <Bulb customClasses="hidden sm:block w-4" />
                            <span className="my-auto">
                                It's currently {dateTime} in Dhyey's city
                            </span>
                        </div>
                        <div className="align-middle lg:text-right" translate="no">
                            © {new Date().getFullYear()} Designed & Built by Dhyey Thumar
                        </div>
                        
                    </Fade>
                </div>
            </div>
        </footer>
    );
};

const mapStateToProps = (state) => {
    return {
        updatedAt: state.common.updatedAt,
    };
};

export default connect(mapStateToProps, null)(Footer);
